import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  label: {
    position: 'relative',
    zIndex: 2,
    fontSize: 12,
    transform: 'none',
    marginBottom: 0,
    lineHeight: '30px',
  },
  inputField: {
    '&:hover': {
      '& fieldset': {
        borderColor: `${theme.palette.primary.main} !important`,
      },
    },
    '& .MuiInputBase-root': {},
    '& .MuiInputAdornment-positionEnd': {
      position: 'relative',
      zIndex: 2,
    },
    '& input': {
      position: 'relative',
      zIndex: 2,
      padding: '11px 14px',
    },
    '& textarea': {
      position: 'relative',
      zIndex: 2,
      padding: 0,
    },
    '& fieldset': {
      backgroundColor: '#fff',
      border: '1px solid #d3d3d3',
      fontSize: 16,
      lineHeight: 18,
      zIndex: 1,
      '&:focus': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .material-icons.icon-eye': {
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
